import {useEffect, useRef} from 'react';

/**
 * Returns the value from the previous render. On the first render it
 * returns `undefined`. Useful for transition detection (e.g. "did this
 * value just change from A to B?") without sprinkling `useRef` +
 * manual update effects around.
 */
export function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T | undefined>(undefined);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
